// Form inline per creare una ricetta dal flusso "Prepara".
// light (free-text) per società senza Acquisti, completa (catalogo) per società con Acquisti.
import { ChevronLeft, Zap, Plus, Trash2, Save, Loader2 } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

const RicettaInlineForm = ({
  hasAcquisti,
  lightNome,
  setLightNome,
  lightComponenti,
  ingredientiDisponibili,
  savingLight,
  onBack,
  onAddComponente,
  onUpdateComponente,
  onSelectIngrediente,
  onRemoveComponente,
  onSave,
}) => {
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2 mb-1">
        <button onClick={onBack} className="p-1 rounded-lg hover:bg-muted">
          <ChevronLeft className="h-4 w-4 text-muted-foreground" />
        </button>
        <div className="flex items-center gap-2">
          <Zap className={`h-4 w-4 ${hasAcquisti ? "text-primary" : "text-amber-500"}`} />
          <span className="text-sm font-bold text-foreground">{hasAcquisti ? "Nuova Ricetta" : "Nuova Ricetta Light"}</span>
        </div>
      </div>

      <div>
        <Label className="text-xs font-bold uppercase tracking-wide">Nome ricetta *</Label>
        <Input value={lightNome} onChange={(e) => setLightNome(e.target.value)} placeholder="Es. Tiramisù, Ragù..." className="h-10 mt-1 bg-card border-border" data-testid="light-nome" autoFocus />
      </div>

      <div>
        <Label className="text-xs font-bold uppercase tracking-wide">{hasAcquisti ? "Ingredienti (dal catalogo)" : "Componenti"}</Label>
        {hasAcquisti && (
          <p className="text-[11px] text-muted-foreground mt-0.5">Seleziona gli ingredienti dal catalogo per calcolare automaticamente il food cost.</p>
        )}
        <div className="space-y-2 mt-1">
          {lightComponenti.map((comp, idx) => (
            <div key={idx} className="flex gap-1.5 items-center">
              {hasAcquisti ? (
                <Select value={comp.ingrediente_id || ""} onValueChange={(v) => onSelectIngrediente(idx, v)}>
                  <SelectTrigger className="flex-1 h-9 text-sm bg-card border-border" data-testid={`light-comp-select-${idx}`}>
                    <SelectValue placeholder="Ingrediente dal catalogo" />
                  </SelectTrigger>
                  <SelectContent className="bg-card border-border max-h-60">
                    {ingredientiDisponibili.map((i) => (
                      <SelectItem key={i.id} value={i.id} className="text-foreground">{i.nome}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              ) : (
                <Input value={comp.nome} onChange={(e) => onUpdateComponente(idx, "nome", e.target.value)} placeholder="Ingrediente" className="flex-1 h-9 text-sm bg-card border-border" data-testid={`light-comp-nome-${idx}`} />
              )}
              <Input type="number" inputMode="decimal" value={comp.quantita} onChange={(e) => onUpdateComponente(idx, "quantita", e.target.value)} placeholder="Qtà" className="w-16 h-9 text-sm bg-card border-border" data-testid={`light-comp-qty-${idx}`} />
              <Select value={comp.unita} onValueChange={(v) => onUpdateComponente(idx, "unita", v)}>
                <SelectTrigger className="w-16 h-9 text-xs bg-card border-border"><SelectValue /></SelectTrigger>
                <SelectContent className="bg-card border-border">
                  <SelectItem value="g">g</SelectItem>
                  <SelectItem value="kg">kg</SelectItem>
                  <SelectItem value="ml">ml</SelectItem>
                  <SelectItem value="lt">lt</SelectItem>
                  <SelectItem value="pz">pz</SelectItem>
                </SelectContent>
              </Select>
              <button onClick={() => onRemoveComponente(idx)} className="p-1 text-red-400 hover:bg-red-500/10 rounded" data-testid={`light-comp-remove-${idx}`}>
                <Trash2 className="h-3.5 w-3.5" />
              </button>
            </div>
          ))}
          <button onClick={onAddComponente} className="w-full flex items-center justify-center gap-1 py-2 rounded-lg border-2 border-dashed border-border text-muted-foreground text-xs font-medium hover:border-primary/50 hover:text-primary transition-colors" data-testid="light-add-comp">
            <Plus className="h-3.5 w-3.5" /> Aggiungi {hasAcquisti ? "ingrediente" : "componente"}
          </button>
        </div>
      </div>

      <Button onClick={onSave} disabled={savingLight || !lightNome.trim() || lightComponenti.filter((c) => c.nome.trim() && (!hasAcquisti || c.ingrediente_id)).length === 0} className={`w-full h-11 font-bold ${hasAcquisti ? "bg-primary hover:bg-primary/90 text-white" : "bg-amber-500 hover:bg-amber-600 text-black"}`} data-testid="salva-light-btn">
        {savingLight ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <Save className="h-4 w-4 mr-2" />}
        {savingLight ? "Salvataggio..." : "Salva e Prepara"}
      </Button>
    </div>
  );
};

export default RicettaInlineForm;
